export default [
  {
    id: 0,
    subsidy_type_id: 1,
    name: 'Market Rent Tenants',
    description: 'Previously market rent tenant(s) at this project.',
    code: '0',
    occupancy_percent: 0.0,
    income_percent: 0.0,
    is_published: false,
    order_num: 0,
    details: {},
  },
  {
    id: 1,
    subsidy_type_id: 1,
    name: 'Section 8',
    description:
      'Pre-1981: Low (80%), very low (50%), and extremely low (30%) income limits. Post-1981: Very low (50%) and extremely low (30%) income limits.',
    code: '1',
    occupancy_percent: 0.0,
    income_percent: 0.0,
    is_published: true,
    order_num: 1,
    details: {
      _translated: {
        en_GB: {
          name: 'Section 8',
          description:
            'Pre-1981: Low (80%), very low (50%), and extremely low (30%) income limits. Post-1981: Very low (50%) and extremely low (30%) income limits.',
        },
        en_US: {
          name: 'Section 8',
          description:
            'Pre-1981: Low (80%), very low (50%), and extremely low (30%) income limits. Post-1981: Very low (50%) and extremely low (30%) income limits.',
        },
      },
    },
  },
  {
    id: 2,
    subsidy_type_id: 1,
    name: 'Rent Supplement',
    description: 'Low (80%) income limit.',
    code: '2',
    occupancy_percent: 0.0,
    income_percent: 0.0,
    is_published: true,
    order_num: 2,
    details: {
      _translated: {
        en_GB: {
          name: 'Rent Supplement',
          description: 'Low (80%) income limit.',
        },
        en_US: {
          name: 'Rent Supplement',
          description: 'Low (80%) income limit.',
        },
        es_CL: {
          name: 'Suplemento de arriendo',
        },
        es_ES: {
          name: 'Suplemento del alquiler',
        },
      },
    },
  },
];
